import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LMBuilderEvent, LMBuilderModel } from "@components/builder/services/lm-builder-model.service";
import { CdkDrag, CdkDragDrop, CdkDropList } from "@angular/cdk/drag-drop";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector:    'lm-builder-summary-totals',
  standalone: false,
  templateUrl: './lm-builder-summary-totals.component.html',
  styleUrl: './lm-builder-summary-totals.component.scss',
})

export class LMBuilderSummaryTotalsComponent implements OnInit, OnDestroy{
  @Input() spec!: LMListPSpec;

  private readonly destroyer$ = new Subject<void>();
  protected readonly LMBuilderModel = LMBuilderModel;
  // private totalModelMap = new Map<string, LMBuilderTotalFieldModel>();

  instanceCount = false;
  // totalFields: Array<LMBuilderTotalFieldModel> = [];

  constructor(
    protected lmBuilderModel: LMBuilderModel
  ) {
    //no-op
  }

  ngOnInit(): void {
    this.lmBuilderModel.builderEvent$.pipe(
        takeUntil(this.destroyer$))
        .subscribe(event => {
          this.handleModelEvent(event);
        });

    this.lmBuilderModel.initializeSummaryTotalFields();
    this.instanceCount = this.lmBuilderModel.summaryInstanceCount;
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  canDrop = (drag: CdkDrag, drop: CdkDropList): boolean => {
    if (drag.dropContainer.data.includes('lm-builder-field')) {
      return this.lmBuilderModel.allowSummaryTotal(drag.data);
    } else if (drag.dropContainer.data.includes(LMBuilderModel.SUMMARY_TOTAL_LIST)) {
      return true;
    }

    return false;
  };

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.data.includes('lm-builder-field')) {
        this.lmBuilderModel.addSummaryTotalField(event.item.data);
    } else if (event.previousContainer.data.includes(LMBuilderModel.SUMMARY_TOTAL_LIST)) {
      this.lmBuilderModel.reorderSummaryTotalField(event.currentIndex, event.previousIndex, event.item.data);
    }
  }


  private handleModelEvent(event:LMBuilderEvent) {
    // if (event === LMBuilderEvent.DISPLAY_FIELD_ADDED || event === LMBuilderEvent.DISPLAY_FIELD_REMOVED) {
    //   this.initialize();
    // }
  }

  updateInstanceCount() {
    this.lmBuilderModel.updateSummaryInstanceCount(this.instanceCount);
  }

  removeField(totalFieldModel: LMBuilderTotalFieldModel) {
  this.lmBuilderModel.removeSummaryTotalField(totalFieldModel);
  }

  updateTotalField(totalFieldModel: LMBuilderTotalFieldModel, operatorModel: LMBuilderTotalOperatorModel) {
    this.lmBuilderModel.updateSummaryTotalField(totalFieldModel, operatorModel);
  }
}
